var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{ref:"form",attrs:{"options":_vm.options,"disabled":_vm.disabled,"labelWidth":"100px"},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }